export default "__VITE_ASSET__AO3tNpNJ__"